// extracted by mini-css-extract-plugin
module.exports = {"base":"title_base__Pwoxi","thin":"title_thin__TA0o5","monotone":"title_monotone__dpStU"};